import { ETHSVG } from "../../utils/svgs";

function NFTCard({ tokenId, price, type = "default", logo }) {
  return (
    <div
      className={`${
        type === "info" ? "bg-secondary" : "bg-[#7D8391]"
      } rounded-[11px] boxShadow m-[22px_18px] overflow-hidden`}
    >
      <div
        className={`${
          type === "default" ? "lg:xs:w-[292px] lg:xs:h-[292px]" : "lg:xs:w-[450px] lg:xs:h-[450px]"
        } xs:w-[240px] xs:h-[240px] w-[200px] h-[200px] flex justify-center items-center`}
      >
        <img src={logo} alt={""} className="xs:scale-100 scale-[80%]" />
      </div>
      <div
        className={`bg-[#E5E5E5]  xs:h-[97px] p-[10px_20px] ${
          type === "default" ? "" : "lg:h-[136px] lg:p-[10px_40px]"
        } h-[80px]`}
      >
        <div
          className={`flex justify-between text-[#7D8391] text-sm ${
            type === "default" ? "" : "lg:text-xl"
          }`}
        >
          <div>#{tokenId}</div>
          <div>
            Last: {price.toFixed(2)} <span className="text-xs">USDT</span>
          </div>
        </div>
        <div
          className={`${
            type === "default" ? "lg:xs:text-xl " : "lg:xs:text-[30px] lg:mt-2"
          } xs:text-lg text-sm text-primary font-semibold -mt-1`}
        >
          TrueApex
        </div>
        <div
          className={`flex items-center text-green font-medium ${
            type === "default" ? "" : "lg:mt-3.5"
          }`}
        >
          <div>{ETHSVG}</div>
          <div
            className={`${
              type === "default" ? "lg:xs:text-xl" : "lg:xs:text-[30px]"
            } xs:text-lg text-sm ml-1.5`}
          >
            {price.toFixed(2)} <span className="xs:text-[15px] text-xs">USDT</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NFTCard;
